import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f1bd6060"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "nerv-section" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 03 // Contact"),
  /*#__PURE__*/_createElementVNode("h1", { class: "nerv-heading nerv-heading-xl section-title" }, "Contact"),
  /*#__PURE__*/_createElementVNode("p", { class: "nerv-lede" }, " Consulting inquiries and hiring conversations both land in the same inbox. Pick the one that fits and it arrives already labelled. ")
], -1))
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "nerv-panel nerv-bracket route-panel" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-data-label" }, "Open a channel", -1))
const _hoisted_6 = { class: "routes" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "route-head" }
const _hoisted_9 = { class: "nerv-heading nerv-heading-md" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "route-arrow",
  "aria-hidden": "true"
}, "↗", -1))
const _hoisted_11 = { class: "nerv-body-sm" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nerv-microcopy note" }, [
  /*#__PURE__*/_createTextVNode(" These open your mail client with the subject filled in. If it does not, write to "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:daniil@dev1consulting.com",
    class: "link"
  }, "daniil@dev1consulting.com"),
  /*#__PURE__*/_createTextVNode(" directly. ")
], -1))
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<section class=\"nerv-panel direct\" data-v-f1bd6060><span class=\"nerv-data-label\" data-v-f1bd6060>Direct channels</span><dl data-v-f1bd6060><div class=\"nerv-datarow\" data-v-f1bd6060><dt class=\"nerv-datarow-key\" data-v-f1bd6060>Email</dt><dd class=\"nerv-datarow-value\" data-v-f1bd6060><a href=\"mailto:daniil@dev1consulting.com\" class=\"link\" data-v-f1bd6060>daniil@dev1consulting.com</a></dd></div><div class=\"nerv-datarow\" data-v-f1bd6060><dt class=\"nerv-datarow-key\" data-v-f1bd6060>Phone</dt><dd class=\"nerv-datarow-value\" data-v-f1bd6060><a href=\"tel:+12149457067\" class=\"link\" data-v-f1bd6060>214-945-7067</a></dd></div><div class=\"nerv-datarow\" data-v-f1bd6060><dt class=\"nerv-datarow-key\" data-v-f1bd6060>LinkedIn</dt><dd class=\"nerv-datarow-value\" data-v-f1bd6060><a href=\"https://www.linkedin.com/in/DaniilDemidov\" target=\"_blank\" rel=\"noopener\" class=\"link\" data-v-f1bd6060> /in/DaniilDemidov </a></dd></div><div class=\"nerv-datarow\" data-v-f1bd6060><dt class=\"nerv-datarow-key\" data-v-f1bd6060>GitHub</dt><dd class=\"nerv-datarow-value\" data-v-f1bd6060><a href=\"https://github.com/iCodeWebApps\" target=\"_blank\" rel=\"noopener\" class=\"link\" data-v-f1bd6060> /iCodeWebApps </a></dd></div><div class=\"nerv-datarow\" data-v-f1bd6060><dt class=\"nerv-datarow-key\" data-v-f1bd6060>Location</dt><dd class=\"nerv-datarow-value\" data-v-f1bd6060>Plano, Texas (Dallas metro)</dd></div><div class=\"nerv-datarow\" data-v-f1bd6060><dt class=\"nerv-datarow-key\" data-v-f1bd6060>Engagements</dt><dd class=\"nerv-datarow-value\" data-v-f1bd6060>Project builds, fractional AI lead, 1099 contract</dd></div><div class=\"nerv-datarow\" data-v-f1bd6060><dt class=\"nerv-datarow-key\" data-v-f1bd6060>Start</dt><dd class=\"nerv-datarow-value\" data-v-f1bd6060>Immediately as 1099 through Dev1 Consulting LLC</dd></div></dl><div class=\"resume-row\" data-v-f1bd6060><a class=\"nerv-btn nerv-btn-ghost\" href=\"/Daniil-Demidov-Resume.pdf\" download data-v-f1bd6060> Download resume (PDF) </a></div><p class=\"nerv-microcopy note\" data-v-f1bd6060> Dev1 Consulting, LLC. Texas domestic LLC, active and in good standing. </p></section>", 1)
const _hoisted_14 = { class: "nerv-section channel" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 03.1 // Channel status", -1))
const _hoisted_16 = { class: "nerv-panel nerv-bracket channel-panel" }
const _hoisted_17 = { class: "channel-gauges" }
const _hoisted_18 = { class: "channel-rows" }
const _hoisted_19 = { class: "nerv-datarow" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "nerv-datarow-key" }, "Status", -1))
const _hoisted_21 = { class: "nerv-datarow-value" }
const _hoisted_22 = { class: "nerv-datarow" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "nerv-datarow-key" }, "Effective type", -1))
const _hoisted_24 = { class: "nerv-datarow-value" }
const _hoisted_25 = { class: "nerv-datarow" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "nerv-datarow-key" }, "Round trip", -1))
const _hoisted_27 = { class: "nerv-datarow-value" }
const _hoisted_28 = { class: "nerv-datarow" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "nerv-datarow-key" }, "Time zone", -1))
const _hoisted_30 = { class: "nerv-datarow-value" }
const _hoisted_31 = { class: "nerv-datarow" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "nerv-datarow-key" }, "Session", -1))
const _hoisted_33 = { class: "nerv-datarow-value" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nerv-microcopy channel-note" }, " Live readings from your browser, measured on this device and rendered here. Nothing is sent, stored or logged. Values the browser does not expose are reported as Unavailable rather than guessed. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NervGauge = _resolveComponent("NervGauge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
            return (_openBlock(), _createElementBlock("li", {
              key: route.label
            }, [
              _createElementVNode("a", {
                href: _ctx.mailto(route),
                class: "route"
              }, [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(route.label), 1),
                  _hoisted_10
                ]),
                _createElementVNode("span", _hoisted_11, _toDisplayString(route.detail), 1)
              ], 8, _hoisted_7)
            ]))
          }), 128))
        ]),
        _hoisted_12
      ]),
      _hoisted_13
    ]),
    _createElementVNode("section", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_NervGauge, {
            label: "Refresh",
            value: _ctx.t.fps,
            max: 120,
            unit: " fps",
            tone: "green",
            size: 140
          }, null, 8, ["value"]),
          (_ctx.t.downlink !== null)
            ? (_openBlock(), _createBlock(_component_NervGauge, {
                key: 0,
                label: "Downlink",
                value: _ctx.t.downlink,
                max: _ctx.downlinkMax,
                unit: " Mb/s",
                tone: "cyan",
                decimals: 1,
                size: 140
              }, null, 8, ["value", "max"]))
            : _createCommentVNode("", true),
          (_ctx.t.batteryLevel !== null)
            ? (_openBlock(), _createBlock(_component_NervGauge, {
                key: 1,
                label: "Battery",
                value: _ctx.t.batteryLevel,
                max: 100,
                unit: "%",
                tone: _ctx.t.batteryCharging ? 'green' : 'magenta',
                size: 140
              }, null, 8, ["value", "tone"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("dl", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("dd", _hoisted_21, _toDisplayString(_ctx.t.online ? 'Online' : 'Offline'), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("dd", _hoisted_24, _toDisplayString(_ctx.t.netType ? _ctx.t.netType.toUpperCase() : 'Unavailable'), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("dd", _hoisted_27, _toDisplayString(_ctx.t.rtt === null ? 'Unavailable' : `${_ctx.t.rtt} ms`), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("dd", _hoisted_30, _toDisplayString(_ctx.t.timezone || 'Unavailable'), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("dd", _hoisted_33, "t+ " + _toDisplayString(_ctx.t.uptime), 1)
          ])
        ]),
        _hoisted_34
      ])
    ])
  ]))
}